exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  display: flex;\n}\n\n.question-icon mdl-icon {\n  font-size: 14px;\n}\n\n.visit-header {\n  white-space: nowrap;\n  text-align: left;\n  padding: 0 4px 0 4px;\n}\n\n.visit-header > div {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.indicator {\n  cursor: pointer;\n  margin-left: 5px;\n}\n\n", ""]);

// exports
